export default __webpack_public_path__ + "media/src/assets/images/EmailIcon-85ad22e21f406d6aaa1854a5a90503cf.svg";